import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-provider-credit-terms',
  templateUrl: './provider-credit-terms.component.html',
  styleUrls: ['./provider-credit-terms.component.scss']
})
export class ProviderCreditTermsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
